// extracted by mini-css-extract-plugin
export default {"text2":"WeightCoefficientsFormControlCaption_text2__f3J1D","subText":"WeightCoefficientsFormControlCaption_subText__o7FrU"};